export class ReferralsPortalForgotPassword {
  public static type: string = 'ReferralsPortalForgotPassword';
  constructor(public payload: { email: string }) {}
}

export class ReferralsPortalResetPassword {
  public static type: string = 'ReferralsPortalResetPassword';
  constructor(
    public payload: {
      token: string;
      emailCode: string;
      password: string;
      passwordConfirmation: string;
    },
  ) {}
}
